function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import React from 'react';
import { colors, spacing, typography } from '../tokens';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export function Table(_ref) {
  var columns = _ref.columns,
    data = _ref.data,
    _ref$keyField = _ref.keyField,
    keyField = _ref$keyField === void 0 ? 'id' : _ref$keyField,
    _ref$emptyMessage = _ref.emptyMessage,
    emptyMessage = _ref$emptyMessage === void 0 ? 'No data available' : _ref$emptyMessage;
  var tableStyle = {
    width: '100%',
    borderCollapse: 'collapse',
    fontFamily: typography.fontFamily,
    fontSize: typography.sizes.sm
  };
  var thStyle = {
    textAlign: 'left',
    padding: spacing.md,
    backgroundColor: colors.neutral[50],
    color: colors.neutral[700],
    borderBottom: "1px solid ".concat(colors.neutral[200]),
    fontWeight: 600
  };
  var tdStyle = {
    padding: spacing.md,
    borderBottom: "1px solid ".concat(colors.neutral[100]),
    color: colors.neutral[900]
  };
  return /*#__PURE__*/_jsx("div", {
    style: {
      overflowX: 'auto'
    },
    children: /*#__PURE__*/_jsxs("table", {
      style: tableStyle,
      children: [/*#__PURE__*/_jsx("thead", {
        children: /*#__PURE__*/_jsx("tr", {
          children: columns.map(function (col) {
            return /*#__PURE__*/_jsx("th", {
              style: thStyle,
              children: col.header
            }, col.key || col.header);
          })
        })
      }), /*#__PURE__*/_jsx("tbody", {
        children: data && data.length > 0 ? data.map(function (row) {
          return /*#__PURE__*/_jsx("tr", {
            children: columns.map(function (col) {
              return /*#__PURE__*/_jsx("td", {
                style: tdStyle,
                children: col.render ? col.render(row[col.key], row) : row[col.key]
              }, col.key || col.header);
            })
          }, row[keyField]);
        }) : /*#__PURE__*/_jsx("tr", {
          children: /*#__PURE__*/_jsx("td", {
            colSpan: columns.length,
            style: _objectSpread(_objectSpread({}, tdStyle), {}, {
              textAlign: 'center',
              color: colors.neutral[500]
            }),
            children: emptyMessage
          })
        })
      })]
    })
  });
}